import { QueryNavLink } from 'shared/lib/react-router-dom';
import styled from 'styled-components';

export const Container = styled.div``;

export const List = styled.ul`
  margin: 0;
  padding: 0;

  list-style: none;
`;

export const ListItem = styled.li``;

export const Link = styled(QueryNavLink)``;
